import React from 'react';

import { PRODUCT_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';
import { AdvancedSearch } from '@confluence/advanced-search';
import { fg } from '@confluence/feature-gating';
import { getValue, isResolved } from '@confluence/lifted-promise';
import { getSessionData } from '@confluence/session-data/entry-points/SessionData.ts';

export const AdvancedSearchRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		} | null;
		MainLayout: {
			navView: string;
			disableMinWidth: boolean;
			fillContainer: boolean;
		};
	};
} = (): React.JSX.Element => <AdvancedSearch />;

AdvancedSearchRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	} | null;
	MainLayout: {
		navView: string;
		disableMinWidth: boolean;
		fillContainer: boolean;
	};
} => {
	// Client routes render after session bootstrap has resolved.
	const sessionData = getSessionData();
	const isRovoEnabled = isResolved(sessionData) && getValue(sessionData)?.isRovoEnabled;

	return {
		Screen: fg('unified_search_in_confluence')
			? null
			: { screenEvent: { name: 'advancedSearchScreen' } },
		MainLayout: {
			navView: PRODUCT_HOME_ID,
			disableMinWidth: true,
			fillContainer:
				(isRovoEnabled || fg('unified_search_in_confluence')) &&
				!fg('confluence_rovo_search_opt_out'),
		},
	};
};
